import React from 'react';
import { MobXProviderContext } from 'mobx-react';
import { IRootStore } from '@stores/index';

/* eslint-disable import/no-default-export */
export default function useStores() {
  return React.useContext(MobXProviderContext) as IRootStore;
}
